import(/* webpackMode: "eager" */ "/frontend/src/app/[lang]/[currency]/(chrome)/tour/[city]/[[...slug]]/TourLayoutClient.tsx")